import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { ListItemButton, ListItemIcon } from "@mui/material";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import CenterFocusStrongRoundedIcon from "@mui/icons-material/CenterFocusStrongRounded";
import InsertChartRoundedIcon from "@mui/icons-material/InsertChartRounded";
import PowerSettingsNewRoundedIcon from "@mui/icons-material/PowerSettingsNewRounded";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";

import { AuthContext } from "../../contexts/authContext";
import { useAuth } from "../../hooks/useAuth";

import classes from "./index.module.scss";
import MedicAirLogo from "../../assets/MedicAirLogo";

const Navigation = () => {
  const { logout } = useContext(AuthContext);
  const { pathname } = useLocation();
  const { isLogged } = useAuth();

  const [readingsOpen, setReadingsOpen] = useState(
    pathname.startsWith("/data")
  );

  const handleReadingsExpand = () => {
    setReadingsOpen(!readingsOpen);
  };

  return !isLogged ? (
    <></>
  ) : (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <div className={classes.logo}>
        <MedicAirLogo color="#fff" />
      </div>

      <List>
        {/* HOME */}
        <ListItemButton
          className={classes.menuButton}
          selected={pathname === "/"}
          key={"home"}
        >
          <ListItemIcon>
            <DashboardRoundedIcon className={classes.menuItemIcon} />
          </ListItemIcon>
          <Link className={classes.menuItem} to="/">
            Home
          </Link>
        </ListItemButton>

        {/* SENSOR READINGS */}
        <ListItemButton
          className={classes.menuButton}
          selected={pathname === "/data"}
          key={"data"}
          onClick={handleReadingsExpand}
        >
          <ListItemIcon>
            <InsertChartRoundedIcon className={classes.menuItemIcon} />
          </ListItemIcon>
          <div
            style={{ width: "100%", justifyContent: "flex-start" }}
            className={classes.menuItem}
          >
            Data
          </div>
          {readingsOpen ? (
            <ExpandLess className={classes.menuItemIcon} />
          ) : (
            <ExpandMore className={classes.menuItemIcon} />
          )}
        </ListItemButton>

        {/* SUB LIST */}
        <Collapse in={readingsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* DATA/PM25 */}
            <ListItemButton
              className={classes.menuButton}
              selected={pathname === "/data/pm25"}
              key={"pm25"}
            >
              <Link className={classes.menuItemNested} to="/data/pm25">
                PM2.5
              </Link>
            </ListItemButton>

            {/* DATA/CO2 */}
            <ListItemButton
              className={classes.menuButton}
              selected={pathname === "/data/co2"}
              key={"co2"}
            >
              <Link className={classes.menuItemNested} to="/data/co2">
                CO2
              </Link>
            </ListItemButton>

            {/* DATA/TEMP */}
            <ListItemButton
              className={classes.menuButton}
              selected={pathname === "/data/temp"}
              key={"temp"}
            >
              <Link className={classes.menuItemNested} to="/data/temp">
                Temperature
              </Link>
            </ListItemButton>

            {/* DATA/HUMIDITY */}
            <ListItemButton
              className={classes.menuButton}
              selected={pathname === "/data/humidity"}
              key={"humidity"}
            >
              <Link className={classes.menuItemNested} to="/data/humidity">
                Humidity
              </Link>
            </ListItemButton>
          </List>
        </Collapse>

        {/* UNITS */}
        <ListItemButton
          className={classes.menuButton}
          selected={pathname === "/units"}
          key={"units"}
        >
          <ListItemIcon>
            <CenterFocusStrongRoundedIcon className={classes.menuItemIcon} />
          </ListItemIcon>
          <Link className={classes.menuItem} to="/units">
            Units
          </Link>
        </ListItemButton>

        {/* USERS */}
        <ListItemButton
          className={classes.menuButton}
          selected={pathname === "/users"}
          key={"users"}
        >
          <ListItemIcon>
            <PeopleRoundedIcon className={classes.menuItemIcon} />
          </ListItemIcon>
          <Link className={classes.menuItem} to="/users">
            Users
          </Link>
        </ListItemButton>
      </List>

      <Divider className={classes.menuDivider} />

      {/* FOOTER */}
      <div className={classes.menuFooter}>
        <ListItemButton className={classes.menuButton} key="Log out">
          <ListItemIcon>
            <PowerSettingsNewRoundedIcon className={classes.menuItemIcon} />
          </ListItemIcon>
          <ListItemText
            className={classes.menuItem}
            primary="Log out"
            style={{ justifyContent: "flex-start" }}
            onClick={logout}
          />
        </ListItemButton>
      </div>
    </Drawer>
  );
};

export default Navigation;
